import { SUCCESS } from '../../../../../constants/action-postfix'
import { COMMISSION_PEOPLES_REQUEST } from '../../commissionActionTypes'

const initialState = []

export const commissionPeoplesReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${COMMISSION_PEOPLES_REQUEST}${SUCCESS}`:
      return action.payload

    default:
      return state
  }
}
